<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Add Recurrence' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12">
        <div
          *ngIf="recurrence && recurrence.id"
          class="alert alert-warning text-center"
          role="alert"
        >
          {{
            'WARNING: A new recurrence will be created in place of this one.'
              | translate
          }}
        </div>

        <form novalidate (ngSubmit)="onSave()" [formGroup]="recurrenceForm">
          <div class="form-group">
            <label for="name" class="control-label">
              {{ 'Name' | translate }} *
            </label>
            <input
              #recurrenceName
              type="text"
              class="form-control"
              tabindex="0"
              id="name"
              placeholder="{{ 'ie. Monthly contract' | translate }}"
              [class.is-invalid]="
                sent && recurrenceForm.get('name').hasError('required')
              "
              formControlName="name"
            />
            <span
              class="invalid-feedback"
              *ngIf="sent && recurrenceForm.get('name').hasError('required')"
            >
              {{ 'global.validators.required.error' | translate }}</span
            >
          </div>

          <div class="form-group">
            <label for="type" class="control-label">
              {{ 'Type' | translate }} *
            </label>
            <select
              tabindex="0"
              name="type"
              id="type"
              class="form-control"
              [class.is-invalid]="
                sent && recurrenceForm.get('type').hasError('required')
              "
              formControlName="type"
            >
              <option
                *ngFor="let type of recurrenceTypes"
                value="{{ type.value }}"
              >
                {{ type.name }}
              </option>
            </select>
            <span
              class="invalid-feedback"
              *ngIf="sent && recurrenceForm.get('type').hasError('required')"
            >
              {{ 'global.validators.required.error' | translate }}</span
            >
          </div>

          <div class="form-group">
            <label for="dateFirst" class="control-label">
              {{ 'Date of first recurrence' | translate }} *
            </label>

            <div class="input-group">
              <input
                tabindex="-1"
                class="form-control"
                readonly
                [class.is-invalid]="
                  sent && recurrenceForm.get('dateFirst').hasError('required')
                "
                [minDate]="dateMin"
                [markDisabled]="disableDay"
                name="dateFirst"
                formControlName="dateFirst"
                ngbDatepicker
                #d="ngbDatepicker"
                placement="bottom-right"
              />
              <div class="input-group-append">
                <button
                  tabindex="0"
                  class="btn btn-light input-group-text"
                  (click)="d.toggle()"
                  type="button"
                >
                  <i class="fe fe-sm fe-calendar"></i>
                </button>
              </div>
            </div>

            <span
              class="invalid-feedback"
              *ngIf="
                sent && recurrenceForm.get('dateFirst').hasError('required')
              "
              >{{ 'global.validators.required.error' | translate }}</span
            >
          </div>

          <div class="form-group">
            <label for="numRecurrences" class="control-label">
              {{ 'Number of recurrences' | translate }}
            </label>
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="numRecurrences"
              formControlName="numRecurrences"
            />
            <span
              class="invalid-feedback"
              *ngIf="
                sent &&
                recurrenceForm.get('numRecurrences').hasError('required')
              "
            >
              {{ 'global.validators.required.error' | translate }} *</span
            >
          </div>

          <div class="form-group mt-2" *ngIf="documentType === 'invoice'">
            <div class="row">
              <div class="col-auto">
                <div
                  class="custom-control custom-checkbox-toggle custom-switch"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="saveAsDraft"
                    formControlName="saveAsDraft"
                  />
                  <label class="custom-control-label" for="saveAsDraft"></label>
                </div>
              </div>
              <div class="col pl-0">
                <label
                  tabindex="0"
                  class="form-check-label"
                  for="saveAsDraft"
                  >{{ 'Create invoice as draft' | translate }}</label
                >
              </div>
            </div>
            <!-- <p class="text-muted mt-3 mb-0">
              {{ 'By enabling cryptocurrencies you will be able to choose crypto as a currency on documents.' | translate }}
            </p> -->
          </div>

          <div class="form-group mb-1 mt-2">
            <div class="row">
              <div class="col-auto">
                <div
                  class="custom-control custom-checkbox-toggle custom-switch"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="autoSend"
                    formControlName="autoSend"
                  />
                  <label class="custom-control-label" for="autoSend"></label>
                </div>
              </div>
              <div class="col pl-0">
                <label tabindex="0" class="form-check-label" for="autoSend">{{
                  'Auto send to customer' | translate
                }}</label>
              </div>
            </div>
            <!-- <p class="text-muted mt-3 mb-0">
              {{ 'By enabling cryptocurrencies you will be able to choose crypto as a currency on documents.' | translate }}
            </p> -->
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="onSave()">
      <span *ngIf="!recurrence || !recurrence.id">{{
        'global.save' | translate
      }}</span>
      <span *ngIf="recurrence && recurrence.id">{{
        'Update' | translate
      }}</span>
      <span *ngIf="loading"
        >&nbsp; <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
      ></span>
    </button>
  </div>
</div>
